<template>
  <div>
    <promised :promise="promise" v-if="!hasError">
      <template #pending>
        <patient-card-widget-skeleton></patient-card-widget-skeleton>
      </template>
      <template #default>
        <p class="chart-widget__description"> {{ chartTitle }}</p>
        <highcharts :key="1" :options="chartOptions" ref="chart"></highcharts>
      </template>
      <template v-slot:rejected="error">
        <p>Error: {{ error.message }}</p>
      </template>
    </promised>
    <div v-else class="widget-permission-error">{{ errorMessage }}</div>
  </div>
</template>

<script>
import WidgetMixin from "@/components/mixins/WidgetMixin";
import PatientCardWidgetSkeleton from "@/components/skeletons/PatientCardWidgetSkeleton";
import { EventBus } from "@/lib/EventBus";
import GenericWidgetGuard from "@/components/permissions/GenericWidgetGuard";
import ChartMixin, {injectFakeDataAction} from "@/components/mixins/ChartMixin";

export default {
  name: "SpiderChartWidget",
  components: {PatientCardWidgetSkeleton},
  mixins: [WidgetMixin, ChartMixin],
  widget: {
    serviceMethod: 'getCharts',
    title: null,
    guard: GenericWidgetGuard
  },
  methods: {
    reflow() {
      if (this.$refs.chart) {
        this.$refs.chart.chart.reflow()
      }
    }
  },
  mounted() {
    EventBus.$on('reflow-chart', this.reflow)
  },
  beforeUnmount() {
    EventBus.$off('reflow-chart', this.reflow)
  },
  afterDataLoaded({ data: [{title, data, subtitle}]}) {
    injectFakeDataAction.call(this)

    if (this.widgetModel.settings.isCentralMonitoring) {
      this.emitSubtitle(title)
    } else {
      this.emitTitle(title)
      this.emitSubtitle(subtitle)
    }
    this.emitTitleTooltip(data.chart_description)

    this.chartDescription = data.chart_description
    this.chartOptions.xAxis.categories = data.categories
    this.chartOptions.series = data.series.map(x => {
      x.data = x.data.map(r => {
        r["y"] = r["value"]
        return r
      })
      return x
    })
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: (9 / 16 * 100) + '%',
          polar: true,
          type: 'line',
          margin: [0, 0, 20, 0]
        },
        title: {
          text: '',
        },
        xAxis: {
          categories: [],
          tickmarkPlacement: 'on',
          lineWidth: 0
        },
        yAxis: {
          gridLineInterpolation: 'polygon',
          labels: {
            enabled: false
          }
        },
        tooltip: {
          formatter() {
            let text = this.point.tooltipText
            if (text) {
              text = `${this.point.series.name}\n${text}`.replace("\n", "<br/>")
            } else {
              text = false
            }
            return text
          }
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false,
        },
        series: []
      }
    }
  }
}
</script>
